module.exports = __webpack_public_path__ + "img/coins3-white.1155fa41.svg";